// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CurrentUserZenDeskJwtQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserZenDeskJwtQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, zendeskJwt: string } | null | undefined };


export const CurrentUserZenDeskJwtDocument = gql`
    query CurrentUserZenDeskJwt {
  currentUser {
    id
    zendeskJwt
  }
}
    `;

/**
 * __useCurrentUserZenDeskJwtQuery__
 *
 * To run a query within a React component, call `useCurrentUserZenDeskJwtQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserZenDeskJwtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserZenDeskJwtQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserZenDeskJwtQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserZenDeskJwtQuery, CurrentUserZenDeskJwtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserZenDeskJwtQuery, CurrentUserZenDeskJwtQueryVariables>(CurrentUserZenDeskJwtDocument, options);
      }
export function useCurrentUserZenDeskJwtLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserZenDeskJwtQuery, CurrentUserZenDeskJwtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserZenDeskJwtQuery, CurrentUserZenDeskJwtQueryVariables>(CurrentUserZenDeskJwtDocument, options);
        }
export function useCurrentUserZenDeskJwtSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserZenDeskJwtQuery, CurrentUserZenDeskJwtQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentUserZenDeskJwtQuery, CurrentUserZenDeskJwtQueryVariables>(CurrentUserZenDeskJwtDocument, options);
        }
export type CurrentUserZenDeskJwtQueryHookResult = ReturnType<typeof useCurrentUserZenDeskJwtQuery>;
export type CurrentUserZenDeskJwtLazyQueryHookResult = ReturnType<typeof useCurrentUserZenDeskJwtLazyQuery>;
export type CurrentUserZenDeskJwtSuspenseQueryHookResult = ReturnType<typeof useCurrentUserZenDeskJwtSuspenseQuery>;
export type CurrentUserZenDeskJwtQueryResult = Apollo.QueryResult<CurrentUserZenDeskJwtQuery, CurrentUserZenDeskJwtQueryVariables>;